import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setGCSVerbalResponseOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'

export function* getGCSVerbalResponseOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const verbalResponse: IOptionsResponse = yield call([optionsService, optionsService.getVerbalResponse])
    const { entity } = verbalResponse
    yield put(setGCSVerbalResponseOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getGCSVerbalResponseOptions() error: ${e}`))
  }
}

export function* getGCSVerbalResponseOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getGCSVerbalResponseOptions)
}
